'use client';

import type { PropsWithChildren, ReactNode } from 'react';

import { walletCachedContext } from './withContextWallet';

type WalletProviderProps = PropsWithChildren;

/**
 * Provider component for wallet data.
 *
 * @param root0 props
 * @param root0.children children component
 * @returns a provider that fetches and provides wallet data to its children components
 */
export function WalletProvider({ children }: WalletProviderProps): ReactNode {
  const { Provider } = walletCachedContext;

  return <Provider>{children}</Provider>;
}
